module.exports = __webpack_public_path__ + "static/Q3_2025_Investor_call_(Dial-in information)-d18bc5bd257a2e3dd6c2d2985e5ac614.pdf";